export default {
    "home": {
        "title": "Home"
    },
    "search": {
        "filter": {
            "buffer_template": "Raio {value} {unity}",
            "items": "Filtro",
            "items_template": "Filtro: {type}"
        },
        "buttons": {
            "search": "Aplicar",
            "sort": "Ordenar"
        }
    },
    "feature": {
        "model": {
            "address": "Morada",
            "name": "Nome",
            "activity": "Temática",
            "category": "Categoria | Categorias",
        }
    }
}

